module.exports = __webpack_public_path__ + "assets/img/busy_9.55d9a7f5.png";